import { Component, Input } from "@angular/core";

// The toolroom's loading state, used in place of the generic spinner on toolroom screens: a Hurco machining
// centre that either has a light sweeping across it ("sweep") or draws itself line by line ("draw").
@Component({
	moduleId: module.id,
	selector: "toolroom-loader",
	styleUrls: ["toolroomLoader.css"],
	templateUrl: "toolroomLoader.html"
})

export class ToolroomLoaderComponent {
	@Input() text = "Loading";
	@Input() variant: "draw" | "sweep" = "sweep";
}
